//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";

function loyaltyTierAuditAPI() {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/loyalty-tier-audit?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/loyalty-tier-audit/search?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function loyaltyTierAuditFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/loyalty-tier-audit/loyalty-tier-audit-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function loyaltyTierAuditExport(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/loyalty-tier-audit/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAllUsers() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/loyalty-tier-audit/all_users`,obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err)
    }  
  }
  async function updateLoyaltyTierAudit(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/loyalty-tier-audit/update`, obj);
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  return {
    getAPI,
    searchAPI,
    loyaltyTierAuditFilter,
    loyaltyTierAuditExport,
    getAllUsers,
    updateLoyaltyTierAudit
  };

}

export default loyaltyTierAuditAPI;
